import { getFallbackFontName, getDefaultFont } from '@pdfme/common';
import { convertForPdfLayoutProps } from '../utils';
import { embedAndGetFontObj } from '../text/pdfRender';
export const pdfRender = async (arg) => {
    try {
        const { page, schema, pdfLib, options, pdfDoc, _cache } = arg;
        const measurementPointId = Number(schema.appRender.measurementPoint);
        const { measurementPoints } = options;
        const measurementPoint = measurementPoints.find(mp => mp.id === measurementPointId);
        if (!measurementPoint) {
            throw new Error(`MeasurementPoint mit ID ${measurementPointId} nicht gefunden.`);
        }
        const { measurements, label } = measurementPoint;
        const pageHeight = page.getHeight();
        const { height, width, position } = convertForPdfLayoutProps({ schema, pageHeight });
        const { x, y } = position;
        const fontSize = 10;
        const rowHeight = 20;
        const fontObj = await embedAndGetFontObj({
            pdfDoc,
            font: options.font ?? getDefaultFont(),
            // @ts-ignore
            _cache,
        });
        const fontName = getFallbackFontName(options.font ?? getDefaultFont());
        const embeddedFont = fontObj[fontName];
        const font = embeddedFont; // Schriftart-Objekt holen
        const drawCenteredText = (text, colIndex, y, bold) => {
            const colX = x + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
            const colWidth = columnWidths[colIndex];
            const textWidth = font.widthOfTextAtSize(text, fontSize);
            const textX = colX + (colWidth - textWidth) / 2;
            console.log(`Text: ${text}, X: ${textX}, Y: ${y}, FontSize: ${fontSize}`);
            page.drawText(text, {
                x: textX,
                y,
                size: fontSize,
                font: bold ? fontObj['Helvetica-Bold'] : font,
            });
        };
        const columnWidths = [
            width * 0.20, // Kontaktstelle
            width * 0.20, // Position
            width * 0.11, // Fd
            width * 0.11, // Td
            width * 0.11, // Fs
            width * 0.11, // Fe
            width * 0.16, // Bewertung
        ];
        const headers = ["Kontaktstelle", "Messung", "Fd [N]", "Td [ms]", "Fs [N]", "Fe [N]", "Bewertung"];
        let currentY = y + height - rowHeight;
        headers.forEach((header, colIndex) => {
            drawCenteredText(header, colIndex, currentY, true);
        });
        const calculateColumnStats = (measurements, key) => {
            const values = measurements.map(m => typeof m.data[key] === 'number' ? m.data[key] : 0);
            const average = values.reduce((sum, val) => sum + val, 0) / values.length || 0;
            const max = Math.max(...values);
            return { average, max };
        };
        const stats = {
            fd: calculateColumnStats(measurements, 'fd'),
            td: calculateColumnStats(measurements, 'td'),
            fs: calculateColumnStats(measurements, 'fs'),
            fe: calculateColumnStats(measurements, 'fe'),
        };
        measurements.forEach((measurement, rowIndex) => {
            currentY -= rowHeight;
            const isGray = rowIndex % 2 === 0;
            if (isGray) {
                page.drawRectangle({
                    x: x,
                    y: currentY - rowHeight / 4,
                    width: width,
                    height: rowHeight,
                    color: pdfLib.rgb(0.9, 0.9, 0.9),
                });
            }
            const values = [
                label,
                measurement.label,
                measurement.data.fd?.toString() || "0",
                measurement.data.td?.toString() || "0",
                measurement.data.fs?.toString() || "0",
                measurement.data.fe?.toString() || "0",
                measurement.data.assessment ? "Pass" : "Fail",
            ];
            values.forEach((value, colIndex) => {
                drawCenteredText(value, colIndex, currentY, false);
            });
        });
        // page.drawText(value, {
        //   x: x + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0),
        //   y: currentY,
        //   size: fontSize,
        // });
        const drawAlignedText = (text, colIndex, y, align, bold = false) => {
            const colX = x + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
            const colWidth = columnWidths[colIndex];
            let textX;
            if (align === 'left') {
                textX = colX + 2; // Leichter Abstand vom linken Rand
            }
            else {
                const textWidth = font.widthOfTextAtSize(text, fontSize);
                textX = colX + (colWidth - textWidth) / 2; // Zentrierung
            }
            page.drawText(text, {
                x: textX,
                y,
                size: fontSize,
                font: bold ? fontObj['Helvetica-Bold'] : font,
            });
        };
        // Anpassung der Summary-Row-Funktion
        const addSummaryRow = (label, values, bgColor) => {
            currentY -= rowHeight;
            page.drawRectangle({
                x: x,
                y: currentY - rowHeight / 4,
                width: width,
                height: rowHeight,
                color: pdfLib.rgb(...bgColor),
            });
            // Label linksbündig
            drawAlignedText(label, 0, currentY, 'left', true);
            // Werte zentriert
            values.forEach((value, colIndex) => {
                drawAlignedText(value.toString(), colIndex + 1, currentY, 'center', false);
            });
        };
        const addEmptyRow = (bgColor) => {
            currentY -= rowHeight;
            page.drawRectangle({
                x: x,
                y: currentY - rowHeight / 4,
                width: width,
                height: rowHeight,
                color: pdfLib.rgb(...bgColor),
            });
        };
        // Füge eine leere Zeile als Abstand hinzu
        addEmptyRow([1, 1, 1]); // Weißer Hintergrund für die leere Zeile
        addSummaryRow("Mittelwert", [
            "",
            stats.fd.average.toFixed(0),
            stats.td.average.toFixed(0),
            stats.fs.average.toFixed(0),
            stats.fe.average.toFixed(0),
            ""
        ], [0.9, 0.9, 0.9]);
        addSummaryRow("Maximalwert", [
            "",
            stats.fd.max.toFixed(0),
            stats.td.max.toFixed(0),
            stats.fs.max.toFixed(0),
            stats.fe.max.toFixed(0),
            ""
        ], [1, 1, 1]);
    }
    catch (error) {
        console.log(error);
    }
};
//# sourceMappingURL=pdfRender.js.map